export const getImageUrl = (imagePath) => {
  if (!imagePath || typeof imagePath !== "string") {
    return "";
  }

  const url = imagePath.trim();

  try {
    const parsedUrl = new URL(url);

    // Check if URL belongs to Google Drive
    if (
      parsedUrl.hostname === "drive.google.com" ||
      parsedUrl.hostname === "www.drive.google.com"
    ) {
      // Supports:
      // /uc?export=view&id=FILE_ID
      // /thumbnail?id=FILE_ID
      // /file/d/FILE_ID/view
      // /open?id=FILE_ID

      const fileMatch = parsedUrl.pathname.match(
        /^\/file\/d\/([a-zA-Z0-9_-]+)/,
      );

      const fileId = parsedUrl.searchParams.get("id") || fileMatch?.[1];

      if (fileId && /^[a-zA-Z0-9_-]+$/.test(fileId)) {
        return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1600`;
      }
    }

    // Other image URLs remain unchanged
    return url;
  } catch {
    return url;
  }
};
